import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class WarningExperiencesEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      id: '',
      name: '',
      designations_list: [],
      warning_experiences: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/experiencias/minimas';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({warning_experiences: responseJson.data});
        }
      }).then(() => {
        var url = config.get('api') + '/designacoes/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({designations_list: responseJson.data});
          }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); });
    });
  }
  
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      designation_id: this.state.designation_id,
      role: this.state.role,
      hours_total: this.state.hours_total,
      hours_operational: this.state.hours_operational,
      hours_model: this.state.hours_model,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/experiencia/minima', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({warning_experiences: responseJson.data});
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  
  // Fetch salvando a edição
  delete(id) {
    this.handleAlert('', '', 'open');
    var datasave = {
      designation_id: this.state.designation_id,
      role: this.state.role,
      hours_total: this.state.hours_total,
      hours_operational: this.state.hours_operational,
      hours_model: this.state.hours_model,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/experiencia/minima/'+id, { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({warning_experiences: responseJson.data});
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.titulo}</h3>
      <hr/>
      <div className="row">
        <div className="col-md-6">
          <form onSubmit={this.add}> 
              <div className="form-group">
                <label>{this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.DesignacaoDoTripulante}:</label>
                <Select
                  className="form-field-name"
                  name="role"
                  value={this.state.role}
                  searchable={true}
                  placeholder={this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.placeholder.SelecionarFuncao}
                  onChange={this.handleSelectChange.bind(this, 'role')}
                  options={[
                    {value: 1, label: this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.opcoesFuncao.Comandante},
                    {value: 2, label: this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.opcoesFuncao.Copiloto},
                    {value: 3, label: this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.opcoesFuncao.Comissario},
                  ]}
                />
              </div>
              <div className="form-roup">
                <label>{this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.MinimoDeHorasParaOperacional}:</label>
                <InputMask value={this.state.hours_operational}  maskChar={null} name="hours_operational" mask="9999999" className="form-control" onChange={this.handleChange.bind(this, 'hours_operational')} placeholder={this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.placeholder.MinimoDeHorasParaOperacional} />
              </div>
              <div className="form-group">
                <label>{this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.RequerTripulanteComDesignacao}:</label>
                <Select
                  className="form-field-name"
                  name="designation_id"
                  value={this.state.designation_id}
                  searchable={true}
                  placeholder={this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.placeholder.SelecionarDesignacao}
                  onChange={this.handleSelectChange.bind(this, 'designation_id')}
                  options={this.state.designations_list}
                />
              </div>
              <div className="form-group">
                <label>{this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.MinimoDeHorasNoModelo}:</label>
                <InputMask value={this.state.hours_model}  maskChar={null} name="hours_model" mask="9999999" className="form-control" onChange={this.handleChange.bind(this, 'hours_model')} placeholder={this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.placeholder.MinimoDeHorasNoModelo} />
              </div>
              <div className="form-group">
                <label>{this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.MinimoDeHorasTotais}:</label>
                <InputMask value={this.state.hours_total}  maskChar={null} name="hours_total" mask="9999999" className="form-control" onChange={this.handleChange.bind(this, 'hours_total')} placeholder={this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.placeholder.MinimoDeHorasTotais} />
              </div>
              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.formulario.botaoAdicionarRequisito}</button>
          </form>
        </div>
        <div className="col-md-6">
          {Object.keys(self.state.warning_experiences).map(function(k) {
            return (
              <table className="table">
                <thead>
                  <tr>
                    <th>{self.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.tabela.DesignacaoDoTripulante}</th>
                    <th>{self.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.tabela.MinimoDeHorasParaOperacional}</th>
                    <th>{self.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.tabela.RequerTripulanteComDesignacao}</th>
                    <th>{self.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.tabela.MinimoDeHorasNoModelo}</th>
                    <th>{self.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.tabela.MinimoDeHorasTotais}</th>
                    <th>{self.locale.RequisitosDeExperiencia.EditarRequisitoDeExperiencia.tabela.Acoes}</th>
                  </tr>
                </thead>
                <tbody id="frotas">
                  <tr>
                    <td>{self.state.warning_experiences[k].role}</td>
                    <td>{self.state.warning_experiences[k].hours_operational}</td>
                    <td>{self.state.warning_experiences[k].designation_name}</td>
                    <td>{self.state.warning_experiences[k].hours_model}</td>
                    <td>{self.state.warning_experiences[k].hours_total}</td>
                    <td>
                      <button className="btn btn-sm btn-danger" value={self.state.warning_experiences[k].id} onClick={() => self.delete(self.state.warning_experiences[k].id)}>
                        <i className="fa fa-fw fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            );
          })}
        </div>
      </div>

    </div>
  </div>
</div>
    );
  }
}

export default WarningExperiencesEdit;



// WEBPACK FOOTER //
// ./src/Components/WarningExperiences/WarningExperiencesEdit.js